export default "__VITE_ASSET__xkRmsTK9__"